import { EvidenceRow } from "../lib/api";

export function StatusPill({ row }: { row: EvidenceRow }) {
  const s = row.status;
  const ots = row.otsState;

  if (s === "finalised" && ots === "anchored") return <span className="pill-verified" title="Timestamp anchored to the Bitcoin blockchain.">Anchored</span>;
  if (s === "finalised") return <span className="pill-pending" title="Bitcoin anchoring usually completes within 24 hours of upload. Your evidence is already sealed and independently verifiable via OpenTimestamps.">Awaiting Bitcoin</span>;
  if (s === "failed") return <span className="pill-failed">Failed</span>;
  if (s === "finalising") return <span className="pill-pending">Finalising</span>;
  if (s === "uploaded") return <span className="pill-pending">Uploaded</span>;
  return <span className="pill-neutral">{s}</span>;
}
